/*
 *@description: 工具库
 *@author: 16071018
 *@email: 16071018@cnsuning.com
 *@time: 2017/04/19 09:21:58
 */

import CONF from '@/app.conf.json';

let Util = {

    /**
     * 跳登录页
     */
    redirectToLogin: function () {

        let targetUrl = window.location.href;

        window.location.href = CONF.PASSPORT.AUTH_URL + "/login?service=" +
            encodeURIComponent(CONF.PASSPORT.IDSAUTH_SERVER_URL + "?targetUrl=" +
                encodeURIComponent(targetUrl)) + "&loginTheme=wap_new";
    },

    /**
     * 用户登录认证
     * @param {function} successFn - 用户登录成功后执行的回调函数
     * @return null
     */
    auth: function (successFn) {

        window.passport_config = CONF.PASSPORT.CONFIG;

        $.probeAuthStatus(function (uesrId) {

            successFn(uesrId);
        }, function () {
            Util.redirectToLogin();
        }, CONF.PASSPORT.CONFIG);
    },

    /**
     * 截取字符串时间
     */
    getStringTime(time) {

        let date = time.split(' '),
            YMD = date[0].split('-'),
            HMS = date[1].split(':'),
            Y = YMD[0],
            M = YMD[1],
            D = YMD[2],
            h = HMS[0],
            m = HMS[1],
            s = HMS[2];

        return {Y, M, D, h, m, s}
    },

    /**
     * 格式化时间
     */
    formatDate(date, connector) {

        return date.getFullYear() + connector + (date.getMonth() + 1) + connector + date.getDate();
    },

    /**
     * 移除json对象中的空值
     * @param ｛Object｝ object 需要处理的对象
     * @return {Object}
     */
    removeFalseKeyInObject(object) {

        let newObj = {};

        for (let key in object) {

            if (object.hasOwnProperty(key) && object[key]) {

                newObj[key] = object[key];
            }
        }

        return newObj;
    },

    getImgUrl(productCode, index, format){
        let imgUrl = CONF.COMMONS.imgUrl
            .replace('{{productCode}}', productCode)
            .replace('{{index}}', index)
            .replace('{{height}}', format)
            .replace('{{width}}', format)

        return imgUrl;
    },

    saCustomInit(fromUrl, fromTitle, toUrl, toTitle){

        window._fromUrl = fromUrl;
        window._fromTitle =  fromTitle;
        window._toUrl = toUrl;
        window._toTitle = toTitle;

        window._saPageViewInit();
    },
  /**
   * 判断是否支持localStorage
   *
   * @function getLocalStorage
   * @example
   *     Util.getLocalStorage()
   * @return {Object} 返回sessionStorage
   */
  getLocalStorage: function () {
    var storage = window.localStorage;

    try {
      storage.setItem('testLocalStorage', 'testLocalStorage');
      storage.removeItem('testLocalStorage');
      return storage;
    } catch (e) {
      console.error('localStorage is not support.');
      // 无痕浏览
      if (window.storage) {
        console.log('localStorage is supported');
        return window.storage;
      } else {
        window.storage = {
          setItem: function (key, value) {
            $.cookie(key, value);
          },
          getItem: function (key) {
            return $.cookie(key);
          },
          removeItem: function (key) {
            $.removeCookie(key);
          }
        };
        console.log('localStorage is supported.');
        return window.storage;
      }
    }
  }
};
export {Util};





// WEBPACK FOOTER //
// ./src/commons/util.js